(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Vap = factory());
})(this, (function () { 'use strict';

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var arrayWithHoles = createCommonjsModule(function (module) {
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(arrayWithHoles);

	var iterableToArrayLimit = createCommonjsModule(function (module) {
	function _iterableToArrayLimit(arr, i) {
	  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
	  if (null != _i) {
	    var _s,
	      _e,
	      _x,
	      _r,
	      _arr = [],
	      _n = !0,
	      _d = !1;
	    try {
	      if (_x = (_i = _i.call(arr)).next, 0 === i) {
	        if (Object(_i) !== _i) return;
	        _n = !1;
	      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
	        ;
	      }
	    } catch (err) {
	      _d = !0, _e = err;
	    } finally {
	      try {
	        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	    return _arr;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(iterableToArrayLimit);

	var arrayLikeToArray = createCommonjsModule(function (module) {
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }
	  return arr2;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(arrayLikeToArray);

	var unsupportedIterableToArray = createCommonjsModule(function (module) {
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(unsupportedIterableToArray);

	var nonIterableRest = createCommonjsModule(function (module) {
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(nonIterableRest);

	var slicedToArray = createCommonjsModule(function (module) {
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _slicedToArray = unwrapExports(slicedToArray);

	var classCallCheck = createCommonjsModule(function (module) {
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _classCallCheck = unwrapExports(classCallCheck);

	var _typeof_1 = createCommonjsModule(function (module) {
	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _typeof = unwrapExports(_typeof_1);

	var toPrimitive = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(toPrimitive);

	var toPropertyKey = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];

	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(toPropertyKey);

	var createClass = createCommonjsModule(function (module) {
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _createClass = unwrapExports(createClass);

	var assertThisInitialized = createCommonjsModule(function (module) {
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _assertThisInitialized = unwrapExports(assertThisInitialized);

	var getPrototypeOf = createCommonjsModule(function (module) {
	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _getPrototypeOf = unwrapExports(getPrototypeOf);

	var superPropBase = createCommonjsModule(function (module) {
	function _superPropBase(object, property) {
	  while (!Object.prototype.hasOwnProperty.call(object, property)) {
	    object = getPrototypeOf(object);
	    if (object === null) break;
	  }
	  return object;
	}
	module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(superPropBase);

	var get = createCommonjsModule(function (module) {
	function _get() {
	  if (typeof Reflect !== "undefined" && Reflect.get) {
	    module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
	  } else {
	    module.exports = _get = function _get(target, property, receiver) {
	      var base = superPropBase(target, property);
	      if (!base) return;
	      var desc = Object.getOwnPropertyDescriptor(base, property);
	      if (desc.get) {
	        return desc.get.call(arguments.length < 3 ? target : receiver);
	      }
	      return desc.value;
	    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  }
	  return _get.apply(this, arguments);
	}
	module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _get = unwrapExports(get);

	var setPrototypeOf = createCommonjsModule(function (module) {
	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(setPrototypeOf);

	var inherits = createCommonjsModule(function (module) {
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _inherits = unwrapExports(inherits);

	var possibleConstructorReturn = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];

	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

	var regeneratorRuntime$1 = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];
	function _regeneratorRuntime() {
	  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
	    return exports;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  var exports = {},
	    Op = Object.prototype,
	    hasOwn = Op.hasOwnProperty,
	    defineProperty = Object.defineProperty || function (obj, key, desc) {
	      obj[key] = desc.value;
	    },
	    $Symbol = "function" == typeof Symbol ? Symbol : {},
	    iteratorSymbol = $Symbol.iterator || "@@iterator",
	    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
	    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	  function define(obj, key, value) {
	    return Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: !0,
	      configurable: !0,
	      writable: !0
	    }), obj[key];
	  }
	  try {
	    define({}, "");
	  } catch (err) {
	    define = function define(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
	      generator = Object.create(protoGenerator.prototype),
	      context = new Context(tryLocsList || []);
	    return defineProperty(generator, "_invoke", {
	      value: makeInvokeMethod(innerFn, self, context)
	    }), generator;
	  }
	  function tryCatch(fn, obj, arg) {
	    try {
	      return {
	        type: "normal",
	        arg: fn.call(obj, arg)
	      };
	    } catch (err) {
	      return {
	        type: "throw",
	        arg: err
	      };
	    }
	  }
	  exports.wrap = wrap;
	  var ContinueSentinel = {};
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	  var getProto = Object.getPrototypeOf,
	    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      define(prototype, method, function (arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if ("throw" !== record.type) {
	        var result = record.arg,
	          value = result.value;
	        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
	          invoke("next", value, resolve, reject);
	        }, function (err) {
	          invoke("throw", err, resolve, reject);
	        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
	          result.value = unwrapped, resolve(result);
	        }, function (error) {
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	      reject(record.arg);
	    }
	    var previousPromise;
	    defineProperty(this, "_invoke", {
	      value: function value(method, arg) {
	        function callInvokeWithMethodAndArg() {
	          return new PromiseImpl(function (resolve, reject) {
	            invoke(method, arg, resolve, reject);
	          });
	        }
	        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	      }
	    });
	  }
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = "suspendedStart";
	    return function (method, arg) {
	      if ("executing" === state) throw new Error("Generator is already running");
	      if ("completed" === state) {
	        if ("throw" === method) throw arg;
	        return doneResult();
	      }
	      for (context.method = method, context.arg = arg;;) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
	          if ("suspendedStart" === state) throw state = "completed", context.arg;
	          context.dispatchException(context.arg);
	        } else "return" === context.method && context.abrupt("return", context.arg);
	        state = "executing";
	        var record = tryCatch(innerFn, self, context);
	        if ("normal" === record.type) {
	          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
	          return {
	            value: record.arg,
	            done: context.done
	          };
	        }
	        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
	      }
	    };
	  }
	  function maybeInvokeDelegate(delegate, context) {
	    var methodName = context.method,
	      method = delegate.iterator[methodName];
	    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
	    var record = tryCatch(method, delegate.iterator, context.arg);
	    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
	    var info = record.arg;
	    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
	  }
	  function pushTryEntry(locs) {
	    var entry = {
	      tryLoc: locs[0]
	    };
	    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
	  }
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal", delete record.arg, entry.completion = record;
	  }
	  function Context(tryLocsList) {
	    this.tryEntries = [{
	      tryLoc: "root"
	    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
	  }
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) return iteratorMethod.call(iterable);
	      if ("function" == typeof iterable.next) return iterable;
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	          next = function next() {
	            for (; ++i < iterable.length;) {
	              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
	            }
	            return next.value = undefined, next.done = !0, next;
	          };
	        return next.next = next;
	      }
	    }
	    return {
	      next: doneResult
	    };
	  }
	  function doneResult() {
	    return {
	      value: undefined,
	      done: !0
	    };
	  }
	  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
	    value: GeneratorFunctionPrototype,
	    configurable: !0
	  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
	    value: GeneratorFunction,
	    configurable: !0
	  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
	    var ctor = "function" == typeof genFun && genFun.constructor;
	    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
	  }, exports.mark = function (genFun) {
	    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
	  }, exports.awrap = function (arg) {
	    return {
	      __await: arg
	    };
	  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    void 0 === PromiseImpl && (PromiseImpl = Promise);
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
	    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
	    return this;
	  }), define(Gp, "toString", function () {
	    return "[object Generator]";
	  }), exports.keys = function (val) {
	    var object = Object(val),
	      keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    return keys.reverse(), function next() {
	      for (; keys.length;) {
	        var key = keys.pop();
	        if (key in object) return next.value = key, next.done = !1, next;
	      }
	      return next.done = !0, next;
	    };
	  }, exports.values = values, Context.prototype = {
	    constructor: Context,
	    reset: function reset(skipTempReset) {
	      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
	        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
	      }
	    },
	    stop: function stop() {
	      this.done = !0;
	      var rootRecord = this.tryEntries[0].completion;
	      if ("throw" === rootRecord.type) throw rootRecord.arg;
	      return this.rval;
	    },
	    dispatchException: function dispatchException(exception) {
	      if (this.done) throw exception;
	      var context = this;
	      function handle(loc, caught) {
	        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
	      }
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i],
	          record = entry.completion;
	        if ("root" === entry.tryLoc) return handle("end");
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc"),
	            hasFinally = hasOwn.call(entry, "finallyLoc");
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
	            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
	          } else {
	            if (!hasFinally) throw new Error("try statement without catch or finally");
	            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
	          }
	        }
	      }
	    },
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
	      var record = finallyEntry ? finallyEntry.completion : {};
	      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
	    },
	    complete: function complete(record, afterLoc) {
	      if ("throw" === record.type) throw record.arg;
	      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
	    },
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
	      }
	    },
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if ("throw" === record.type) {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	      throw new Error("illegal catch attempt");
	    },
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      return this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
	    }
	  }, exports;
	}
	module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	unwrapExports(regeneratorRuntime$1);

	// TODO(Babel 8): Remove this file.

	var runtime = regeneratorRuntime$1();
	var regenerator = runtime;

	// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	function __awaiter(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}

	/*
	 * Tencent is pleased to support the open source community by making vap available.
	 *
	 * Copyright (C) 2020 THL A29 Limited, a Tencent company.  All rights reserved.
	 *
	 * Licensed under the MIT License (the "License"); you may not use this file except in
	 * compliance with the License. You may obtain a copy of the License at
	 *
	 * http://opensource.org/licenses/MIT
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under the License is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
	 * either express or implied. See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FrameParser = /*#__PURE__*/function () {
	  function FrameParser(source, headData) {
	    _classCallCheck(this, FrameParser);
	    this.config = source || {};
	    this.headData = headData;
	    this.frame = [];
	    this.textureMap = {};
	  }
	  _createClass(FrameParser, [{
	    key: "init",
	    value: function init() {
	      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
	        return regenerator.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.initCanvas();
	                // 判断是url还是json对象
	                if (!/\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.json$/.test(this.config)) {
	                  _context.next = 5;
	                  break;
	                }
	                _context.next = 4;
	                return this.getConfigBySrc(this.config);
	              case 4:
	                this.config = _context.sent;
	              case 5:
	                _context.next = 7;
	                return this.parseSrc(this.config);
	              case 7:
	                this.canvas.parentNode.removeChild(this.canvas);
	                this.frame = this.config.frame || [];
	                return _context.abrupt("return", this);
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	    }
	  }, {
	    key: "initCanvas",
	    value: function initCanvas() {
	      var canvas = document.createElement("canvas");
	      var ctx = canvas.getContext("2d");
	      canvas.style.display = "none";
	      document.body.appendChild(canvas);
	      this.ctx = ctx;
	      this.canvas = canvas;
	    }
	  }, {
	    key: "loadImg",
	    value: function loadImg(url) {
	      return new Promise(function (resolve, reject) {
	        // console.log('load img:', url)
	        var img = new Image();
	        img.crossOrigin = "anonymous";
	        img.onload = function () {
	          resolve(this);
	        };
	        img.onerror = function (e) {
	          console.error("frame 资源加载失败:" + url);
	          reject(new Error("frame 资源加载失败:" + url));
	        };
	        img.src = url;
	      });
	    }
	  }, {
	    key: "parseSrc",
	    value: function parseSrc(dataJson) {
	      var _this = this;
	      var src = this.srcData = {};
	      return Promise.all((dataJson.src || []).map(function (item) {
	        return __awaiter(_this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee2() {
	          var _this2 = this;
	          return regenerator.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  item.img = null;
	                  if (!(!this.headData[item.srcTag.slice(1, item.srcTag.length - 1)] && !this.headData[item.srcTag])) {
	                    _context2.next = 5;
	                    break;
	                  }
	                  console.warn("vap: \u878D\u5408\u4FE1\u606F\u6CA1\u6709\u4F20\u5165\uFF1A".concat(item.srcTag));
	                  _context2.next = 22;
	                  break;
	                case 5:
	                  if (!(item.srcType === "txt")) {
	                    _context2.next = 11;
	                    break;
	                  }
	                  if (this.headData["fontStyle"] && !item["fontStyle"]) {
	                    item["fontStyle"] = this.headData["fontStyle"];
	                  }
	                  item.textStr = this.headData[item.srcTag] || item.srcTag.replace(/\[(.*)\]/, function ($0, $1) {
	                    return _this2.headData[$1];
	                  });
	                  item.img = this.makeTextImg(item);
	                  _context2.next = 21;
	                  break;
	                case 11:
	                  if (!(item.srcType === "img")) {
	                    _context2.next = 21;
	                    break;
	                  }
	                  item.imgUrl = this.headData[item.srcTag] || item.srcTag.replace(/\[(.*)\]/, function ($0, $1) {
	                    return _this2.headData[$1];
	                  });
	                  _context2.prev = 13;
	                  _context2.next = 16;
	                  return this.loadImg(item.imgUrl);
	                case 16:
	                  item.img = _context2.sent;
	                  _context2.next = 21;
	                  break;
	                case 19:
	                  _context2.prev = 19;
	                  _context2.t0 = _context2["catch"](13);
	                case 21:
	                  if (item.img) {
	                    src[item.srcId] = item;
	                  }
	                case 22:
	                case "end":
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, this, [[13, 19]]);
	        }));
	      }));
	    }
	    /**
	     * 下载json文件
	     * @param jsonUrl json外链
	     * @returns {Promise}
	     */
	  }, {
	    key: "getConfigBySrc",
	    value: function getConfigBySrc(jsonUrl) {
	      return new Promise(function (resolve, reject) {
	        var xhr = new XMLHttpRequest();
	        xhr.open("GET", jsonUrl, true);
	        xhr.responseType = "json";
	        xhr.onload = function () {
	          if (xhr.status === 200 || xhr.status === 304 && xhr.response) {
	            var res = xhr.response;
	            resolve(res);
	          } else {
	            reject(new Error("http response invalid" + xhr.status));
	          }
	        };
	        xhr.send();
	      });
	    }
	    /**
	     * 文字转换图片
	     * @param item
	     */
	  }, {
	    key: "makeTextImg",
	    value: function makeTextImg(item) {
	      var textStr = item.textStr,
	        w = item.w,
	        h = item.h,
	        color = item.color,
	        style = item.style,
	        fontStyle = item.fontStyle;
	      var ctx = this.ctx;
	      ctx.canvas.width = w;
	      ctx.canvas.height = h;
	      ctx.textBaseline = "middle";
	      ctx.textAlign = "center";
	      var getFontStyle = function getFontStyle() {
	        var fontSize = Math.min(w / textStr.length, h - 8); // 需留一定间隙
	        var font = ["".concat(fontSize, "px"), "Arial"];
	        if (style === "b") {
	          font.unshift("bold");
	        }
	        return font.join(" ");
	      };
	      if (!fontStyle) {
	        ctx.font = getFontStyle();
	        ctx.fillStyle = color;
	      } else if (typeof fontStyle == "string") {
	        ctx.font = fontStyle;
	        ctx.fillStyle = color;
	      } else if (_typeof(fontStyle) == "object") {
	        ctx.font = fontStyle["font"] || getFontStyle();
	        ctx.fillStyle = fontStyle["color"] || color;
	      } else if (typeof fontStyle == "function") {
	        ctx.font = getFontStyle();
	        ctx.fillStyle = color;
	        fontStyle.call(null, ctx, item);
	      }
	      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
	      ctx.fillText(textStr, w / 2, h / 2);
	      // console.log('frame : ' + textStr, ctx.canvas.toDataURL('image/png'))
	      return ctx.getImageData(0, 0, w, h);
	    }
	  }, {
	    key: "getFrame",
	    value: function getFrame(frame) {
	      return this.frame.find(function (item) {
	        return item.i === frame;
	      });
	    }
	  }]);
	  return FrameParser;
	}();

	/*
	 * Tencent is pleased to support the open source community by making vap available.
	 *
	 * Copyright (C) 2020 THL A29 Limited, a Tencent company.  All rights reserved.
	 *
	 * Licensed under the MIT License (the "License"); you may not use this file except in
	 * compliance with the License. You may obtain a copy of the License at
	 *
	 * http://opensource.org/licenses/MIT
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under the License is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
	 * either express or implied. See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createShader(gl, type, source) {
	  var shader = gl.createShader(type);
	  gl.shaderSource(shader, source);
	  gl.compileShader(shader);
	  // if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	  //     console.error(gl.getShaderInfoLog(shader))
	  // }
	  return shader;
	}
	function createProgram(gl, vertexShader, fragmentShader) {
	  var program = gl.createProgram();
	  gl.attachShader(program, vertexShader);
	  gl.attachShader(program, fragmentShader);
	  gl.linkProgram(program);
	  // if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
	  //     console.error(gl.getProgramInfoLog(program))
	  // }
	  gl.useProgram(program);
	  return program;
	}
	function createTexture(gl, index, imgData) {
	  var texture = gl.createTexture();
	  var textrueIndex = gl.TEXTURE0 + index;
	  gl.activeTexture(textrueIndex);
	  gl.bindTexture(gl.TEXTURE_2D, texture);
	  // gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	  if (imgData) {
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, imgData);
	  }
	  return texture;
	}

	var VapVideo = /*#__PURE__*/function () {
	  function VapVideo(options) {
	    _classCallCheck(this, VapVideo);
	    this.customEvent = ["frame", "percentage"];
	    if (!options.container || !options.src) {
	      console.warn("[Alpha video]: options container and src cannot be empty!");
	    }
	    this.options = Object.assign({
	      // 视频url
	      src: "",
	      // 循环播放
	      loop: false,
	      fps: 20,
	      // 视频宽度
	      width: 375,
	      // 视频高度
	      height: 375,
	      // 容器
	      container: null,
	      // 是否预加载视频资源
	      precache: false,
	      // 是否静音播放
	      mute: false,
	      config: "",
	      accurate: false,
	      // 帧偏移, 一般没用, 预留支持问题素材
	      offset: 0
	    }, options);
	    this.fps = 20;
	    this.setBegin = true;
	    this.useFrameCallback = false;
	    this.isError = false;
	    this.requestAnim = this.requestAnimFunc();
	    this.container = this.options.container;
	    if (!this.options.src || !this.options.config || !this.options.container) {
	      console.error("参数出错：src(视频地址)、config(配置文件地址)、container(dom容器)");
	    } else {
	      // 创建video
	      if (this.options.mode !== "suspend") {
	        this.initVideo();
	      }
	    }
	  }
	  _createClass(VapVideo, [{
	    key: "precacheSource",
	    value: function precacheSource(source) {
	      var URL = window.webkitURL || window.URL;
	      return new Promise(function (resolve, reject) {
	        var xhr = new XMLHttpRequest();
	        xhr.open("GET", source, true);
	        xhr.responseType = "blob";
	        xhr.onload = function () {
	          if (xhr.status === 200 || xhr.status === 304) {
	            var res = xhr.response;
	            if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
	              var fileReader = new FileReader();
	              fileReader.onloadend = function () {
	                var resultStr = fileReader.result;
	                var raw = atob(resultStr.slice(resultStr.indexOf(",") + 1));
	                var buf = Array(raw.length);
	                for (var d = 0; d < raw.length; d++) {
	                  buf[d] = raw.charCodeAt(d);
	                }
	                var arr = new Uint8Array(buf);
	                var blob = new Blob([arr], {
	                  type: "video/mp4"
	                });
	                resolve(URL.createObjectURL(blob));
	              };
	              fileReader.readAsDataURL(xhr.response);
	            } else {
	              resolve(URL.createObjectURL(res));
	            }
	          } else {
	            reject(new Error("http response invalid" + xhr.status));
	          }
	        };
	        xhr.send();
	      });
	    }
	  }, {
	    key: "initVideo",
	    value: function initVideo() {
	      var _this = this;
	      var options = this.options;
	      // 创建video
	      var video = this.video = document.createElement("video");
	      video.crossOrigin = 'anonymous';
	      video.autoplay = false;
	      video.preload = "auto";
	      video.setAttribute("playsinline", "");
	      video.setAttribute("webkit-playsinline", "");
	      if (options.mute) {
	        video.muted = true;
	        video.volume = 0;
	      }
	      video.style.display = "none";
	      video.loop = !!options.loop;
	      if (options.precache) {
	        this.precacheSource(options.src).then(function (blob) {
	          console.log("sample precached.");
	          video.src = blob;
	          document.body.appendChild(video);
	        })["catch"](function (e) {
	          console.error(e);
	        });
	      } else {
	        video.src = options.src;
	        // 这里要插在body上，避免container移动带来无法播放的问题
	        document.body.appendChild(this.video);
	        video.load();
	      }
	      if ("requestVideoFrameCallback" in this.video) {
	        this.useFrameCallback = !!this.options.accurate;
	      }
	      // 绑定事件
	      this.events = {};
	      ["playing", "pause", "ended", "error", "canplay"].forEach(function (item) {
	        _this.on(item, _this["on" + item].bind(_this));
	      });
	    }
	  }, {
	    key: "drawFrame",
	    value: function drawFrame(_, info) {
	      this._drawFrame = this._drawFrame || this.drawFrame.bind(this, _, info);
	      if (this.useFrameCallback) {
	        // @ts-ignore
	        this.animId = this.video.requestVideoFrameCallback(this.drawFrame.bind(this));
	      } else {
	        if (!this.isError) {
	          this.animId = this.requestAnim(this._drawFrame);
	        }
	      }
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      var _this2 = this;
	      var prom = this.video && this.video.play();
	      if (prom && prom.then) {
	        prom["catch"](function (e) {
	          if (!_this2.video) {
	            return;
	          }
	          _this2.video.muted = true;
	          _this2.video.volume = 0;
	          _this2.video.play()["catch"](function (e) {
	            (_this2.events.error || []).forEach(function (item) {
	              item(e);
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.video && this.video.pause();
	    }
	  }, {
	    key: "setTime",
	    value: function setTime(t) {
	      if (this.video) {
	        this.video.currentTime = t;
	      }
	    }
	  }, {
	    key: "requestAnimFunc",
	    value: function requestAnimFunc() {
	      var me = this;
	      if (window.requestAnimationFrame) {
	        var index = -1;
	        return function (cb) {
	          index++;
	          return requestAnimationFrame(function () {
	            if (!(index % (60 / me.fps))) {
	              return cb();
	            }
	            me.animId = me.requestAnim(cb);
	          });
	        };
	      }
	      return function (cb) {
	        return setTimeout(cb, 1000 / me.fps);
	      };
	    }
	  }, {
	    key: "cancelRequestAnimation",
	    value: function cancelRequestAnimation() {
	      if (this.useFrameCallback) {
	        try {
	          // @ts-ignore
	          this.video.cancelVideoFrameCallback(this.animId);
	        } catch (e) {}
	      } else if (window.cancelAnimationFrame) {
	        cancelAnimationFrame(this.animId);
	      } else {
	        clearTimeout(this.animId);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.cancelRequestAnimation();
	      if (this.video) {
	        this.video.parentNode && this.video.parentNode.removeChild(this.video);
	        this.video = null;
	      }
	      this.options.onDestory && this.options.onDestory();
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.destroy();
	    }
	  }, {
	    key: "on",
	    value: function on(event, callback) {
	      var cbs = this.events[event] || [];
	      cbs.push(callback);
	      this.events[event] = cbs;
	      if (this.customEvent.indexOf(event) === -1) {
	        this.video.addEventListener(event, callback);
	      }
	      return this;
	    }
	  }, {
	    key: "onplaying",
	    value: function onplaying() {
	      if (this.options.mode === "suspend") {
	        if (!this.useFrameCallback) {
	          this.drawFrame(null, null);
	        }
	      } else {
	        if (!this.firstPlaying) {
	          this.firstPlaying = true;
	          if (!this.useFrameCallback) {
	            this.drawFrame(null, null);
	          }
	        }
	      }
	    }
	  }, {
	    key: "onpause",
	    value: function onpause() {}
	  }, {
	    key: "onended",
	    value: function onended() {
	      if (this.options.mode === "suspend") {
	        // _get(_getPrototypeOf(WebglRenderVap.prototype), "destroy", this).call(this);
	        // _get(WebglRenderVap.prototype, "clearFrame", this).call(this);
	        try {
	          VapVideo.prototype.destroy.bind(this).call(this);
	          this.clearFrame();
	        } catch (err) {
	          console.error(err);
	        }
	      } else {
	        this.destroy();
	      }
	    }
	  }, {
	    key: "oncanplay",
	    value: function oncanplay() {
	      var begin = this.options.beginPoint;
	      if (begin && this.setBegin) {
	        this.setBegin = false;
	        this.video.currentTime = begin;
	      }
	    }
	  }, {
	    key: "onerror",
	    value: function onerror(err) {
	      console.error("[Alpha video]: play error: ", err);
	      this.isError = true;
	      // this.destroy();
	      this.options.onLoadError && this.options.onLoadError(err);
	    }
	  }]);
	  return VapVideo;
	}();

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var clearTimer = null;
	var instances = {};
	var PER_SIZE = 9;
	function computeCoord(x, y, w, h, vw, vh) {
	  // leftX rightX bottomY topY
	  return [x / vw, (x + w) / vw, (vh - y - h) / vh, (vh - y) / vh];
	}
	var WebglRenderVap = /*#__PURE__*/function (_VapVideo) {
	  _inherits(WebglRenderVap, _VapVideo);
	  var _super = _createSuper(WebglRenderVap);
	  function WebglRenderVap(options) {
	    var _this;
	    _classCallCheck(this, WebglRenderVap);
	    _this = _super.call(this, options);
	    if (_this.useFrameCallback) {
	      // @ts-ignore
	      _this.animId = _this.video.requestVideoFrameCallback(_this.drawFrame.bind(_assertThisInitialized(_this)));
	    }
	    _this.insType = _this.options.type;
	    if (instances[_this.insType]) {
	      _this.instance = instances[_this.insType];
	    } else {
	      _this.instance = instances[_this.insType] = {};
	    }
	    _this.textures = [];
	    _this.buffers = [];
	    _this.shaders = [];
	    _this.init();
	    return _this;
	  }
	  _createClass(WebglRenderVap, [{
	    key: "init",
	    value: function init() {
	      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
	        return regenerator.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setCanvas();
	                if (!this.options.config) {
	                  _context.next = 12;
	                  break;
	                }
	                _context.prev = 2;
	                _context.next = 5;
	                return new FrameParser(this.options.config, this.options).init();
	              case 5:
	                this.vapFrameParser = _context.sent;
	                this.resources = this.vapFrameParser.srcData;
	                _context.next = 12;
	                break;
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](2);
	                console.error("[Alpha video] parse vap frame error.", _context.t0);
	              case 12:
	                this.resources = this.resources || {};
	                this.initWebGL();
	                this.play();
	              case 15:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[2, 9]]);
	      }));
	    }
	  }, {
	    key: "setCanvas",
	    value: function setCanvas() {
	      var canvas = this.instance.canvas;
	      var _this$options = this.options,
	        width = _this$options.width,
	        height = _this$options.height;
	      if (!canvas) {
	        canvas = this.instance.canvas = document.createElement("canvas");
	      }
	      canvas.width = width;
	      canvas.height = height;
	      this.container.appendChild(canvas);
	    }
	  }, {
	    key: "initWebGL",
	    value: function initWebGL() {
	      var canvas = this.instance.canvas;
	      var _this$instance = this.instance,
	        gl = _this$instance.gl,
	        vertexShader = _this$instance.vertexShader,
	        fragmentShader = _this$instance.fragmentShader,
	        program = _this$instance.program;
	      if (!canvas) {
	        return;
	      }
	      if (!gl) {
	        this.instance.gl = gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
	        gl.disable(gl.BLEND);
	        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
	        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
	      }
	      // 清除界面，解决同类型type切换MP4时，第一帧是上一个mp4最后一帧的问题
	      gl.clear(gl.COLOR_BUFFER_BIT);
	      if (gl) {
	        gl.viewport(0, 0, canvas.width, canvas.height);
	        if (!vertexShader) {
	          vertexShader = this.instance.vertexShader = this.initVertexShader();
	        }
	        if (!fragmentShader) {
	          fragmentShader = this.instance.fragmentShader = this.initFragmentShader();
	        }
	        if (!program) {
	          program = this.instance.program = createProgram(gl, vertexShader, fragmentShader);
	        }
	        this.program = program;
	        this.initTexture();
	        this.initVideoTexture();
	        return gl;
	      }
	    }
	    /**
	     * 顶点着色器
	     */
	  }, {
	    key: "initVertexShader",
	    value: function initVertexShader() {
	      var gl = this.instance.gl;
	      return createShader(gl, gl.VERTEX_SHADER, "attribute vec2 a_position; // \u63A5\u53D7\u9876\u70B9\u5750\u6807\n             attribute vec2 a_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807\n             attribute vec2 a_alpha_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807\n             varying vec2 v_alpha_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807\n             varying   vec2 v_texcoord; // \u4F20\u9012\u7EB9\u7406\u5750\u6807\u7ED9\u7247\u5143\u7740\u8272\u5668\n             void main(void){\n                gl_Position = vec4(a_position, 0.0, 1.0); // \u8BBE\u7F6E\u5750\u6807\n                v_texcoord = a_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807\n                v_alpha_texCoord = a_alpha_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807\n             }");
	    }
	  }, {
	    key: "clearFrame",
	    value: function clearFrame() {
	      var gl = this.instance.gl;
	      if (gl) {
	        gl.clear(gl.COLOR_BUFFER_BIT);
	      }
	    }
	    /**
	     * 片元着色器
	     */
	  }, {
	    key: "initFragmentShader",
	    value: function initFragmentShader() {
	      var gl = this.instance.gl;
	      var bgColor = "vec4(texture2D(u_image_video, v_texcoord).rgb, texture2D(u_image_video,v_alpha_texCoord).r);";
	      var textureSize = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1;
	      // const textureSize =0
	      var sourceTexure = "";
	      var sourceUniform = "";
	      if (textureSize > 0) {
	        var imgColor = [];
	        var samplers = [];
	        for (var i = 0; i < textureSize; i++) {
	          imgColor.push("if(ndx == ".concat(i + 1, "){\n                        color = texture2D(u_image").concat(i + 1, ",uv);\n                    }"));
	          samplers.push("uniform sampler2D u_image".concat(i + 1, ";"));
	        }
	        sourceUniform = "\n            ".concat(samplers.join("\n"), "\n            uniform float image_pos[").concat(textureSize * PER_SIZE, "];\n            vec4 getSampleFromArray(int ndx, vec2 uv) {\n                vec4 color;\n                ").concat(imgColor.join(" else "), "\n                return color;\n            }\n            ");
	        sourceTexure = "\n            vec4 srcColor,maskColor;\n            vec2 srcTexcoord,maskTexcoord;\n            int srcIndex;\n            float x1,x2,y1,y2,mx1,mx2,my1,my2; //\u663E\u793A\u7684\u533A\u57DF\n\n            for(int i=0;i<".concat(textureSize * PER_SIZE, ";i+= ").concat(PER_SIZE, "){\n                if ((int(image_pos[i]) > 0)) {\n                  srcIndex = int(image_pos[i]);\n    \n                    x1 = image_pos[i+1];\n                    x2 = image_pos[i+2];\n                    y1 = image_pos[i+3];\n                    y2 = image_pos[i+4];\n                    \n                    mx1 = image_pos[i+5];\n                    mx2 = image_pos[i+6];\n                    my1 = image_pos[i+7];\n                    my2 = image_pos[i+8];\n    \n    \n                    if (v_texcoord.s>x1 && v_texcoord.s<x2 && v_texcoord.t>y1 && v_texcoord.t<y2) {\n                        srcTexcoord = vec2((v_texcoord.s-x1)/(x2-x1),(v_texcoord.t-y1)/(y2-y1));\n                         maskTexcoord = vec2(mx1+srcTexcoord.s*(mx2-mx1),my1+srcTexcoord.t*(my2-my1));\n                         srcColor = getSampleFromArray(srcIndex,srcTexcoord);\n                         maskColor = texture2D(u_image_video, maskTexcoord);\n                         srcColor.a = srcColor.a*(maskColor.r);\n                      \n                         bgColor = vec4(srcColor.rgb*srcColor.a,srcColor.a) + (1.0-srcColor.a)*bgColor;\n                      \n                    }   \n                }\n            }\n            ");
	      }
	      var fragmentSharder = "\n        precision lowp float;\n        varying vec2 v_texcoord;\n        varying vec2 v_alpha_texCoord;\n        uniform sampler2D u_image_video;\n        ".concat(sourceUniform, "\n        \n        void main(void) {\n            vec4 bgColor = ").concat(bgColor, "\n            ").concat(sourceTexure, "\n            // bgColor = texture2D(u_image[0], v_texcoord);\n            gl_FragColor = bgColor;\n        }\n        ");
	      return createShader(gl, gl.FRAGMENT_SHADER, fragmentSharder);
	    }
	  }, {
	    key: "initTexture",
	    value: function initTexture() {
	      var gl = this.instance.gl;
	      var i = 1;
	      if (!this.vapFrameParser || !this.vapFrameParser.srcData) {
	        return;
	      }
	      var resources = this.vapFrameParser.srcData;
	      for (var key in resources) {
	        var resource = resources[key];
	        this.textures.push(createTexture(gl, i, resource.img));
	        var _sampler = gl.getUniformLocation(this.program, "u_image".concat(i));
	        gl.uniform1i(_sampler, i);
	        this.vapFrameParser.textureMap[resource.srcId] = i++;
	      }
	      var dumpTexture = gl.createTexture();
	      gl.activeTexture(gl.TEXTURE0);
	      gl.bindTexture(gl.TEXTURE_2D, dumpTexture);
	      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	      this.videoTexture = createTexture(gl, i);
	      var sampler = gl.getUniformLocation(this.program, "u_image_video");
	      gl.uniform1i(sampler, i);
	    }
	  }, {
	    key: "initVideoTexture",
	    value: function initVideoTexture() {
	      var gl = this.instance.gl;
	      var vertexBuffer = gl.createBuffer();
	      this.buffers.push(vertexBuffer);
	      if (!this.vapFrameParser || !this.vapFrameParser.config || !this.vapFrameParser.config.info) {
	        return;
	      }
	      var info = this.vapFrameParser.config.info;
	      var ver = [];
	      var vW = info.videoW,
	        vH = info.videoH;
	      var _info$rgbFrame = _slicedToArray(info.rgbFrame, 4),
	        rgbX = _info$rgbFrame[0],
	        rgbY = _info$rgbFrame[1],
	        rgbW = _info$rgbFrame[2],
	        rgbH = _info$rgbFrame[3];
	      var _info$aFrame = _slicedToArray(info.aFrame, 4),
	        aX = _info$aFrame[0],
	        aY = _info$aFrame[1],
	        aW = _info$aFrame[2],
	        aH = _info$aFrame[3];
	      var rgbCoord = computeCoord(rgbX, rgbY, rgbW, rgbH, vW, vH);
	      var aCoord = computeCoord(aX, aY, aW, aH, vW, vH);
	      ver.push.apply(ver, [-1, 1, rgbCoord[0], rgbCoord[3], aCoord[0], aCoord[3]]);
	      ver.push.apply(ver, [1, 1, rgbCoord[1], rgbCoord[3], aCoord[1], aCoord[3]]);
	      ver.push.apply(ver, [-1, -1, rgbCoord[0], rgbCoord[2], aCoord[0], aCoord[2]]);
	      ver.push.apply(ver, [1, -1, rgbCoord[1], rgbCoord[2], aCoord[1], aCoord[2]]);
	      var view = new Float32Array(ver);
	      gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
	      gl.bufferData(gl.ARRAY_BUFFER, view, gl.STATIC_DRAW);
	      this.aPosition = gl.getAttribLocation(this.program, "a_position");
	      gl.enableVertexAttribArray(this.aPosition);
	      this.aTexCoord = gl.getAttribLocation(this.program, "a_texCoord");
	      gl.enableVertexAttribArray(this.aTexCoord);
	      this.aAlphaTexCoord = gl.getAttribLocation(this.program, "a_alpha_texCoord");
	      gl.enableVertexAttribArray(this.aAlphaTexCoord);
	      // 将缓冲区对象分配给a_position变量、a_texCoord变量
	      var size = view.BYTES_PER_ELEMENT;
	      gl.vertexAttribPointer(this.aPosition, 2, gl.FLOAT, false, size * 6, 0); // 顶点着色器位置
	      gl.vertexAttribPointer(this.aTexCoord, 2, gl.FLOAT, false, size * 6, size * 2); // rgb像素位置
	      gl.vertexAttribPointer(this.aAlphaTexCoord, 2, gl.FLOAT, false, size * 6, size * 4); // rgb像素位置
	    }
	  }, {
	    key: "drawFrame",
	    value: function drawFrame(_, info) {
	      var _this2 = this;
	      var timePoint = info && info.mediaTime >= 0 ? info.mediaTime : this.video.currentTime;
	      var frame = Math.round(timePoint * this.options.fps) + this.options.offset;
	      var frameCbs = this.events["frame"] || [];
	      frameCbs.forEach(function (cb) {
	        cb(frame + 1, timePoint);
	      });
	      var gl = this.instance.gl;
	      if (!gl) {
	        _get(_getPrototypeOf(WebglRenderVap.prototype), "drawFrame", this).call(this, _, info);
	        return;
	      }
	      gl.clear(gl.COLOR_BUFFER_BIT);
	      if (this.vapFrameParser) {
	        var frameData = this.vapFrameParser.getFrame(frame);
	        var posArr = [];
	        if (frameData && frameData.obj) {
	          frameData.obj.forEach(function (frame, index) {
	            posArr[posArr.length] = +_this2.vapFrameParser.textureMap[frame.srcId];
	            var info = _this2.vapFrameParser.config.info;
	            var vW = info.videoW,
	              vH = info.videoH;
	            // frame坐标是最终展示坐标，这里glsl中计算使用视频坐标
	            var _info$rgbFrame2 = _slicedToArray(info.rgbFrame, 2),
	              rgbX = _info$rgbFrame2[0],
	              rgbY = _info$rgbFrame2[1];
	            var _frame$frame = _slicedToArray(frame.frame, 4),
	              x = _frame$frame[0],
	              y = _frame$frame[1],
	              w = _frame$frame[2],
	              h = _frame$frame[3];
	            var _frame$mFrame = _slicedToArray(frame.mFrame, 4),
	              mX = _frame$mFrame[0],
	              mY = _frame$mFrame[1],
	              mW = _frame$mFrame[2],
	              mH = _frame$mFrame[3];
	            var coord = computeCoord(x + rgbX, y + rgbY, w, h, vW, vH);
	            var mCoord = computeCoord(mX, mY, mW, mH, vW, vH);
	            posArr = posArr.concat(coord).concat(mCoord);
	          });
	        }
	        //
	        var size = (gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1) * PER_SIZE;
	        posArr = posArr.concat(new Array(size - posArr.length).fill(0));
	        this._imagePos = this._imagePos || gl.getUniformLocation(this.program, "image_pos");
	        gl.uniform1fv(this._imagePos, new Float32Array(posArr));
	      }
	      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, this.video); // 指定二维纹理方式
	      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
	      _get(_getPrototypeOf(WebglRenderVap.prototype), "drawFrame", this).call(this, _, info);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      var _this$instance2 = this.instance,
	        canvas = _this$instance2.canvas,
	        gl = _this$instance2.gl;
	      if (this.textures && this.textures.length) {
	        for (var i = 0; i < this.textures.length; i++) {
	          gl.deleteTexture(this.textures[i]);
	        }
	      }
	      if (canvas) {
	        canvas.parentNode && canvas.parentNode.removeChild(canvas);
	      }
	      // glUtil.cleanWebGL(gl, this.shaders, this.program, this.textures, this.buffers)
	      _get(_getPrototypeOf(WebglRenderVap.prototype), "destroy", this).call(this);
	      this.clearMemoryCache();
	    }
	  }, {
	    key: "clearMemoryCache",
	    value: function clearMemoryCache() {
	      if (clearTimer) {
	        clearTimeout(clearTimer);
	      }
	      clearTimer = setTimeout(function () {
	        instances = {};
	      }, 30 * 60 * 1000);
	    }
	  }]);
	  return WebglRenderVap;
	}(VapVideo);

	var isCanWebGL;
	/**
	 * @param options
	 * @constructor
	 * @return {null}
	 */
	function index (options) {
	  if (canWebGL()) {
	    return new WebglRenderVap(Object.assign({}, options));
	  } else {
	    throw new Error('your browser not support webgl');
	  }
	}
	function canWebGL() {
	  if (typeof isCanWebGL !== 'undefined') {
	    return isCanWebGL;
	  }
	  try {
	    // @ts-ignore
	    if (!window.WebGLRenderingContext) {
	      return false;
	    }
	    var canvas = document.createElement('canvas');
	    var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
	    isCanWebGL = !!context;
	    context = null;
	  } catch (err) {
	    isCanWebGL = false;
	  }
	  return isCanWebGL;
	}

	return index;

}));
